import { CURRENCIES_RECEIVED } from 'actions/currencies'

export default function currencies(state={}, action) {
  switch(action.type) {
    case CURRENCIES_RECEIVED:
      return action.currencies
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/currencies.js
 **/